import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";
import styles from "./Progress.module.scss";

function Progress(props) {
  const { progress, color, size, speed } = props;
  return (
    <ProgressContainer size={size}>
      <ProgressTrack progress={progress} color={color} speed={speed} />
    </ProgressContainer>
  );
}

Progress.propTypes = {
  color: PropTypes.oneOf([
    "purple",
    "green",
    "red",
    "teal",
    "orange",
    "softGray",
  ]),
  progress: PropTypes.number,
  size: PropTypes.string,
};

Progress.defaultProps = {
  color: "purple",
};

function ProgressContainer(props) {
  const { children, size } = props;
  const containerClasses = cx(styles.container, {
    [styles.large]: size === "lg",
  });

  return <div className={containerClasses}>{children}</div>;
}

export function ProgressTrack(props) {
  const { progress, color, speed } = props;
  const trackClasses = cx(styles.track, {
    [styles.purple]: color === "purple",
    [styles.green]: color === "green",
    [styles.red]: color === "red",
    [styles.teal]: color === "teal",
    [styles.orange]: color === "orange",
    [styles.softGray]: color === "softGray",
    [styles.slower]: speed === "slower",
  });

  return <div className={trackClasses} style={{ width: `${progress}%` }} />;
}

export default Progress;
